import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import Teckstackgame from "../../ae/components/teckstackgame";

function Brand(props) {
  return (
    <div className="brandsol stack_web p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="my-auto text-center"
          >
            <h2>Our Next-Gen Technologies for Game Development Programs</h2>
            <p>
              Become a part of the future development in the gaming industry by
              deploying the innovative technologies that we utilize in the
              development of your game. Here are some exceptional game app
              development tools that we leverage to craft stunning gaming
              experiences:
            </p>
            <Teckstackgame />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Brand;
